var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 12.5002H5L11.5625 5.93769C11.7267 5.77354 11.8569 5.57866 11.9457 5.36418C12.0345 5.14971 12.0803 4.91984 12.0803 4.68769C12.0803 4.45554 12.0345 4.22567 11.9457 4.01119C11.8569 3.79672 11.7267 3.60184 11.5625 3.43769C11.3983 3.27354 11.2035 3.14332 10.989 3.05449C10.7745 2.96565 10.5446 2.91992 10.3125 2.91992C10.0804 2.91992 9.85048 2.96565 9.63601 3.05449C9.42153 3.14332 9.22665 3.27354 9.0625 3.43769L2.5 10.0002V12.5002Z",
    stroke: "#0066CC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4375 4.0625L10.9375 6.5625",
    stroke: "#0066CC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBlue);
export default __webpack_public_path__ + "static/media/Edit_Blue.69e150e431d4974c96a8b18df7ae6fa0.svg";
export { ForwardRef as ReactComponent };